var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1048.66 571.846L1082 596.552C1082 600.889 1077.07 616.663 1074.6 624.008C1070.64 634.128 1062.23 645.347 1051.96 652.913L1055.88 706H999.28V652.913C960.531 646.498 977.477 557.205 997.541 544L1048.66 571.846Z",
    fill: "#FF9494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1000.01 657H1000V652.757C1001.85 652.757 1005.35 652.757 1009.02 652.528C1012.75 652.297 1016.48 651.841 1018.87 651L1020 655.05C1017.12 656.063 1012.97 656.533 1009.23 656.765C1005.44 657 1001.86 657 1000.01 657Z",
    fill: "#2D2B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M954.986 538.751C935.529 564.655 992.465 605.607 1014.51 586.855C1043.34 562.326 1045.94 599.414 1045.94 599.414C1055.09 588.512 1070.91 601.216 1066.23 615.926C1062.04 629.099 1077.26 648.409 1085.99 606.315C1108.49 606.315 1131.78 553.469 1084.39 536.332C1064.07 490.968 1010.62 505.637 1010.62 521.855C988.362 505.447 973.016 526.468 979.171 538.751C975.949 532.316 960.732 531.096 954.986 538.751Z",
    fill: "#2D2B38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M968 1874V1764H871.839V1784.6L770 1820.53V1874H849.991H884.081H909.436H968Z",
    fill: "#6372FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.69 1790.86L1180.32 1691.2L1092.46 1731.2L1100.95 1749.86L1022.73 1824.79L1044.78 1873.23L1117.86 1839.96L1149.01 1825.78L1172.18 1815.23L1225.69 1790.86Z",
    fill: "#6372FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M833.321 1781H1066L969.415 1385L1066 1047H825.418L782 1385L833.321 1781Z",
    fill: "#2D2B38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1012.21 1685L1027.96 1764.6C1028.08 1765.19 1027.93 1765.8 1027.54 1766.26C1027.17 1766.73 1026.6 1767 1026 1767H910V1762.99H1023.56L1008.27 1685.78L1012.21 1685Z",
    fill: "#2D2B38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1025 1771L1199 1693.54L1065.32 1407.64C1121.22 1266.58 1139.84 1186.6 1146.45 1042H932.462L868 1407.64L1025 1771Z",
    fill: "#2D2B38"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1137.15 1595.26L1171.85 1679.97C1172.16 1680.49 1172.21 1681.11 1172 1681.68C1171.79 1682.24 1171.34 1682.67 1170.77 1682.87L1061.79 1730.87L1060.49 1727.09L1167.17 1679.88L1133.69 1597.27L1137.15 1595.26Z",
    fill: "#FAFAFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M905.973 1409.16L937.485 1227.69L933.615 1227L902 1409.06L1004.1 1601L1008 1600.52L905.973 1409.16Z",
    fill: "#FAFAFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M921.485 726.086L904.718 669.866C904.718 669.866 756.443 753.156 756.443 818.817C756.443 884.478 846.177 890.022 894.205 859.779L1018.38 781.587C1051.34 760.829 1051.96 712.994 1019.55 691.385C1004.33 681.241 985.011 679.532 968.253 686.841L861.914 791.933L921.485 726.086Z",
    fill: "#5061FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M826 1047L1148 1046.56L1128.29 768.02C1123.66 702.471 1040.36 662.741 978.744 685.42C949.038 696.354 926.415 720.891 917.476 751.283C906.592 788.283 891.123 839.222 877.703 877.323C853.575 945.822 826 1047 826 1047Z",
    fill: "#6372FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M909.793 1038.24L855.209 1033.43C854.775 1033.39 854.375 1033.18 854.101 1032.84C853.826 1032.5 853.7 1032.06 853.754 1031.64L861.129 971.323L864.323 971.712L857.15 1030.37L910.076 1035.04L909.793 1038.24Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.29 1069.98C1155.93 1099.38 1118.61 1149.53 1096.18 1140.96C1070.19 1131.04 1068.84 1079.73 1093.7 1073.53C1084.19 1074.1 1067.73 1073.78 1071.03 1064.24C1077.66 1045.08 1123.84 1026.18 1135.35 1034.04L1171.29 1069.98Z",
    fill: "#FF9494"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M998.924 680.774C1029.26 675.178 1096.64 684.911 1123.52 708.176C1166.82 745.644 1269.46 888.097 1255.88 954.274C1247.28 996.152 1222.31 1031.35 1173.49 1075.24L1114.31 1023.95L1167.47 925.839C1167.47 925.839 1017.91 707.868 993.681 713.709C1007.1 699.262 981.163 684.051 998.924 680.774Z",
    fill: "#6372FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M906.479 676.157C931.885 659.05 984.258 634.789 998.723 651.711C1015.48 671.318 994.031 713.669 971.094 707.686C979.076 711.44 992.311 719.006 985.434 725.305C971.627 737.95 925.79 732.846 919.883 721.342L906.479 676.157Z",
    fill: "#FF9494"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1096.82 814.932L1142.97 891.722L1140.05 892.949L1093.89 816.158L1096.82 814.932Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.67 966.324L1111.25 969.073L1156.84 933.287L1152.01 933.087L1109.67 966.324Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M740.654 392.134C712.145 361.224 713.973 313.164 744.738 284.788C775.503 256.412 823.555 258.466 852.064 289.376C864.016 302.334 870.636 318.307 872.027 334.579C875.273 372.549 868.924 419.43 894.761 447.442L895.873 448.648",
    stroke: "black",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M982.946 214.543C984.914 165.828 1025.82 127.924 1074.3 129.883C1122.79 131.841 1160.5 172.921 1158.54 221.637C1157.55 246.02 1146.81 267.695 1130.25 283.018C1102.28 308.898 1065.93 337.164 1064.39 375.241L1063.87 388.135",
    stroke: "#6372FF",
    strokeWidth: 40,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.57 354.074C1191.17 323.29 1223.79 306.078 1254.43 315.629C1285.07 325.18 1302.12 357.878 1292.53 388.662C1288.64 401.135 1280.97 411.38 1271.19 418.52C1247.02 436.154 1212.46 450.26 1203.55 478.822",
    stroke: "#2D2B38",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.49 471.939C1073.08 472.448 1083.7 462.651 1084.21 450.056C1084.72 437.462 1074.93 426.84 1062.33 426.331C1049.74 425.823 1039.11 435.62 1038.61 448.214C1038.1 460.808 1047.89 471.43 1060.49 471.939Z",
    fill: "#6372FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.56 514.131C1196.54 515.68 1201.82 512.906 1203.37 507.934C1204.92 502.962 1202.15 497.675 1197.18 496.126C1192.2 494.576 1186.92 497.35 1185.37 502.322C1183.82 507.294 1186.59 512.581 1191.56 514.131Z",
    fill: "#2D2B38"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M914.483 484.094C919.088 489.086 926.868 489.4 931.86 484.796C936.852 480.191 937.167 472.412 932.562 467.419C927.957 462.427 920.178 462.113 915.185 466.717C910.193 471.322 909.879 479.102 914.483 484.094Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.f3e4be866ffcbda503f17028ab4831d6.svg";
export { ForwardRef as ReactComponent };